import { useCallback, useState } from 'react';
import { useCurrentSectionIndex } from '@/features/quote-and-apply-builder';

export function useFormEditorSidebar() {
  const currentSectionIndex = useCurrentSectionIndex();
  const [lastToggledSection, setLastToggledSection] = useState<number | null>(null);

  const isExpanded = useCallback(
    (sectionIndex: number) =>
      sectionIndex === currentSectionIndex ||
      (lastToggledSection !== null && lastToggledSection === sectionIndex),
    [currentSectionIndex, lastToggledSection],
  );

  const toggleSection = useCallback(
    (sectionIndex: number) => {
      if (sectionIndex === currentSectionIndex) return;
      setLastToggledSection(previous => (previous === sectionIndex ? null : sectionIndex));
    },
    [currentSectionIndex],
  );

  return {
    isExpanded,
    toggleSection,
  };
}
